import React from "react";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, LineChart, Line, Tooltip } from 'recharts';
import moment from 'moment';

import './paymentChart.scss';

class PaymentChart extends React.Component {
    render(){ 
        const data = this.props.data.map(d => { d.value = d.value > 27 ? 27 : d.value < 0 ? 0 : Math.round(d.value); return d })
        if (data.length === 0)
            return null;

        var maxValue = Math.max.apply(Math, data.map(function(d) { return d.value; }));
        var minValue = Math.min.apply(Math, data.map(function(d) { return d.value; }));

        var maxGraphValue = maxValue + 2 > 27 ? 27 : maxValue + 2;
        var minGraphValue = minValue - 2 < 0 ? 0 : minValue - 2;

        // If all values are the same the line will not be rendered when using linearGradient
        // Calculate gradient colors, pick the right color for the values and use it instead of linearGradient (see Line tag below)
        let firstVal = data[0].value;
        const sameValues = data.every(v => v.value === firstVal);
        let color = null;
        if (sameValues) {
            const col = generateGradientColors([243, 68, 84], [159, 211, 0], 28)[firstVal];
            color = `rgb(${col.join()})`;
        }

        return (
            <>
                <div className="w-100 text-center" style={{ fontSize: "2.5em", fontWeight: "600" }}>
                    {this.props.header}
                </div>
                <div style={{fontSize:'.7em'}}>
                    <ResponsiveContainer width="99%" height={85}>
                        <LineChart data={data} height={85} margin={{ top: 10, left: 10, right: 40 }}>
                            <defs>
                                <linearGradient id="pmntChart" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop className="payment-chart-stop-0" offset="0%" stopOpacity={0.5} />
                                    <stop className="payment-chart-stop-100" offset="100%" stopOpacity={0.5} />
                                </linearGradient>
                            </defs>
                            <XAxis stroke="#CCC" dataKey="date" tickFormatter={(d) => moment(d).format('L')} tickLine={false} className="aaa" />
                            <YAxis stroke="#CCC" dataKey="value" domain={[minGraphValue, maxGraphValue]} ticks={getTicksY(minGraphValue, maxGraphValue)} type="number"
                                tickFormatter={(v) => getRatingFromValue(v)} tickLine={false} interval={0} width={40} />
                            <CartesianGrid stroke="#CCC" vertical={false} strokeWidth={1} />
                            <Tooltip cursor={false}  content={<CustomTooltip />} wrapperStyle={tooltipStyle} />
                            <Line 
                                type="monotone" dataKey="value" strokeWidth={3} dot={false} 
                                stroke={`${sameValues ? color : `url('${window.location.pathname}#pmntChart')`}`} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </>
        )
    }
}

const ratings = ['D', 'C-', 'C', 'C+', 'CC-', 'CC', 'CC+', 'CCC-', 'CCC', 'CCC+',
    'B-', 'B', 'B+', 'BB-', 'BB', 'BB+', 'BBB-', 'BBB', 'BBB+', 'A-', 'A', 'A+',
    'AA-', 'AA', 'AA+', 'AAA-', 'AAA', 'AAA+'
]

function generateGradientColors(colorStart, colorEnd, colorCount){
    var alpha = 0.0;
    var colors = [];

    for (let i = 0; i < colorCount; i++) {
        var c = [];
        alpha += (1.0 / colorCount);

        c[0] = Math.round(colorStart[0] * alpha + (1 - alpha) * colorEnd[0]);
        c[1] = Math.round(colorStart[1] * alpha + (1 - alpha) * colorEnd[1]);
        c[2] = Math.round(colorStart[2] * alpha + (1 - alpha) * colorEnd[2]);
        colors.push(c);
    }

    return colors.reverse();
}

const getTicksY = (minGraphValue, maxGraphValue) => {
    var off = (maxGraphValue - minGraphValue) / 5;
    var ticks = [];
    for (let index = 0; index < 5; index++) {
        ticks.push(Math.round((index*off) + minGraphValue));
    }
    ticks.push(maxGraphValue);

    ticks.filter((item, index) => ticks.indexOf(item) === index)

    return ticks;
}

const tooltipStyle = {
    padding: "0.35em 2em",
    background: "#FFF",
    border: "1px solid #DEDEDE",
    boxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)",
    WebkitBoxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)"
}

const getRatingFromValue = (value) => {
    return ratings[Math.round(value)];
}

const CustomTooltip = ({ active, payload }) => {
    if (active) {
        return (
            <div className="payment-chart-tooltip">
                <div style={{ fontWeight: "600", fontSize: "1.2em" }}>{payload[0].payload.rating}</div>
                <div style={{ fontSize: "1em" }}>{new Date(payload[0].payload.date).toLocaleDateString("cs")} </div>
            </div>
        )
    }
    return null;
}

export default PaymentChart;